function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 125,
  r: 100,
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "border",
  cx: 125,
  cy: 125,
  r: 105,
  stroke: "white",
  strokeWidth: 10
})), /*#__PURE__*/React.createElement("rect", {
  x: 96,
  y: 141,
  width: 57,
  height: 13,
  rx: 6.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -13,
  y: -10,
  width: 276,
  height: 276,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 12,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.796078 0 0 0 0 0.356863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-14 68) rotate(21.3916) scale(220.705)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.230076,
  stopColor: "#FFE927"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642194,
  stopColor: "#FFE43B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989483,
  stopColor: "#FFD66D"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 250,
  fill: "white"
})));

var SvgOkface = function SvgOkface(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOkface, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ok face.d524498a.svg";
export { ForwardRef as ReactComponent };